var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3725_998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7992 19V45C52.7992 55.4 50.1992 58 39.7992 58H24.1992C13.7992 58 11.1992 55.4 11.1992 45V19C11.1992 8.6 13.7992 6 24.1992 6H39.7992C50.1992 6 52.7992 8.6 52.7992 19Z",
    stroke: "#FFE500",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1988 15.1H26.7988",
    stroke: "#FFE500",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9968 50.46C34.2225 50.46 36.0268 48.6557 36.0268 46.43C36.0268 44.2043 34.2225 42.4 31.9968 42.4C29.7711 42.4 27.9668 44.2043 27.9668 46.43C27.9668 48.6557 29.7711 50.46 31.9968 50.46Z",
    stroke: "#FFE500",
    strokeWidth: 3.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3725_998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert3);
export default __webpack_public_path__ + "static/media/Alert3.f3186ff97f5b452eb9847d742cab6545.svg";
export { ForwardRef as ReactComponent };